import * as angular from "angular";
import { IController } from "angular";
import {AccountPreferredAgent} from "../../../account/models/account-preferred-agent.model";
import {AccountModel} from "../../../account/angular/models/account.model";

export class VisitPlanAccountInfoComponentController implements IController {
  account: AccountModel;
  preferred: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean};
  dedicated: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean};
  restricted: {agents: AccountPreferredAgent[], shouldRedirectToRanking: boolean};
}


angular
  .module('bringoz.admin.scheduling-project')
  .component('visitPlanAccountInfoComponent', {
    bindings: {
      account: '<',
      preferred: '<',
      dedicated: '<',
      restricted: '<',
    },
    template: require('./visit-plan-account-info-component.html').default,
    controller: VisitPlanAccountInfoComponentController
  });
